<!-- =========================================================================================
File Name: RegisterSanctum.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <vs-input
          placeholder="Email"
          v-model="email"
          class="w-full mt-3"
        />
        <field-error :errorsBag="formErrors" fieldName="email"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-input
          type="password"
          placeholder="Hasło"
          v-model="password"
          class="w-full mt-3"
        />
        <field-error :errorsBag="formErrors" fieldName="password"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-input
          type="password"
          placeholder="Powtórz hasło"
          v-model="passwordConfirmation"
          class="w-full mt-3"
        />
        <field-error :errorsBag="formErrors" fieldName="password_confirmation"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="mb-0 mt-3">Dane osobowe</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4" class="pr-lg-3">
        <vs-input
          placeholder="Imię"
          v-model="firstName"
          class="w-full mt-3"
        />
        <field-error :errorsBag="formErrors" fieldName="first_name"/>
      </b-col>
      <b-col lg="4" class="pr-lg-3 pl-lg-0">
        <vs-input
          placeholder="Nazwisko"
          v-model="lastName"
          class="w-full mt-3"
        />
        <field-error :errorsBag="formErrors" fieldName="last_name"/>
      </b-col>
      <b-col lg="4" class="pl-lg-0">
        <b-form-select
          :options="genderItems"
          v-model="gender"
          class="w-full mt-3 h-12"
        />
        <field-error :errorsBag="formErrors" fieldName="gender"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-select
          v-model="province"
          :options="provinces"
          class="w-full mt-3 h-12"
        />
        <field-error :errorsBag="formErrors" fieldName="province"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-input
          placeholder="Nazwa instytucji"
          v-model="employmentCompany"
          class="w-full mt-3"
        />
        <field-error :errorsBag="formErrors" fieldName="employment_company"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pr-3">
        <b-form-select
          v-model="employmentPosition"
          :options="employmentPositionItems"
          class="w-full mt-3 h-12"
        />
        <field-error :errorsBag="formErrors" fieldName="employment_position"/>
      </b-col>
      <b-col class="pl-0" v-if="this.employmentPosition==='lekarz'">
        <vs-input
          placeholder="Numer licencji"
          v-model="licenseNumber"
          class="w-full mt-3"
        />
        <field-error :errorsBag="formErrors" fieldName="license_number"/>
      </b-col>
    </b-row>
    <b-row v-if="registerAgreementsState">
      <b-col class="mt-3">
        <div v-for="(a, index) in registerAgreements" :key="index">
          <div class="flex items-center justify-between">
            <vs-checkbox v-model="registerAgreementsState[a.uuid]" v-bind:class="{ required: a.is_required }">
              {{ a.name }}
            </vs-checkbox>
            <vs-button type="flat" @click="$bvModal.show(a.uuid)">Zobacz</vs-button>
          </div>
          <field-error :errorsBag="formErrors" :fieldName="'agreements.'+a.uuid"/>
          <b-modal :id="a.uuid" centered>
            <template #modal-header><h4>{{ a.name }}</h4></template>
            <div v-html="a.full_content"></div>
            <template #modal-footer>
              <vs-button type="border rounded" @click="$bvModal.hide(a.uuid)">Zamknij</vs-button>
            </template>
          </b-modal>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-button type="filled rounded" class="mt-3" @click="registerUser">Utwórz konto</vs-button>
      </b-col>
    </b-row>
    <b-row class="mt-10 mb-8">
      <b-col cols="12" class="pl-0">
        <p class="mb-0 mt-3">Masz już konto?</p>
      </b-col>
      <b-col cols="12">
        <vs-button type="border rounded" to="/pages/login" class="mt-3">Zaloguj się</vs-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import notification from './../../../notification'
import FieldError from './../../../components/wod/forms/FieldError'
import userFormItems from "@/mixins/users/userFormItems"

export default {
  components: {
    notification,
    FieldError
  },

  mixins: [userFormItems],

  data() {
    return {
      email: null,
      password: null,
      passwordConfirmation: null,
      firstName: null,
      lastName: null,
      gender: null,
      province: null,
      employmentCompany: null,
      employmentPosition: null,
      licenseNumber: null,
      registerAgreementsState: null,
      formErrors: {},
      provinces: []
    }
  },

  computed: {
    registerAgreements() {
      return this.$store.state.agreements.registerAgreements
    }
  },
  mounted() {
    this.getRegisterAgreements()
    this.provinces = this.sortProvinces()
  },
  methods: {
    sortProvinces() {
      return this.provinceItems.sort((a, b) => {
        const nameA = a.text.toUpperCase();
        const nameB = b.text.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })
    },
    getRegisterAgreements() {
      this.$vs.loading()
      this.$store.dispatch('agreements/getRegisterFormAgreements')
        .then((response) => {
          this.setRegisterAgreementsState()
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },

    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.loggedInUser != null) {
        this.$vs.notify(notification.error('Jesteś już zalogowany'))
        return false
      }
      return true
    },

    registerUser() {
      this.clearFormErrors()
      this.$vs.loading()
      const payload = {
        email: this.email,
        password: this.password,
        password_confirmation: this.passwordConfirmation,
        first_name: this.firstName,
        last_name: this.lastName,
        gender: this.gender,
        province: this.province,
        employment_company: this.employmentCompany,
        employment_position: this.employmentPosition,
        agreements: this.registerAgreementsState
      }
      if (this.employmentPosition === "lekarz") {
        payload.license_number = this.licenseNumber

      }
      this.$store.dispatch('auth/registerUserSanctum', payload)
        .then((response) => {
          this.$vs.notify(notification.success('Użytkownik został zarejestrowany'))
          this.$router.push('/pages/login')
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 422) {
              this.formErrors = error.response.data.errors
            } else {
              this.$vs.notify(notification.error(error.message))
            }
          }
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },

    clearFormErrors() {
      this.FieldError = {}
    },

    setRegisterAgreementsState() {
      this.registerAgreementsState = {}
      this.registerAgreements.map(a => {
        this.registerAgreementsState[a.uuid] = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.required::after {
  padding-left: 2px;
  content: '*';
  color: rgba(var(--vs-danger), 1);
}
</style>
